import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UserPermissionsModalComponent } from '../../users/edit-user/user-permissions-modal/user-permissions-modal.component';
import { SharedModule } from '../../shared/shared.module';
import { EditUserComponent } from './edit-user.component';
import { RegisterAuthDeviceModalComponent } from './register-auth-device-modal/register-auth-device-modal.component';
import { UserChangePasswordModalComponent } from './user-change-password-modal/user-change-password-modal.component';
import { UserLoginHistoryComponent } from './user-login-history/user-login-history.component';
import { UserMouComponent } from './user-mou/user-mou.component';
import { UserNotificationComponent } from './user-notifications/user-notifications.component';
import { UserMultiFactorAuthenticationComponent } from './user-multi-factor-authentication/user-multi-factor-authentication.component';
import { UserAssociateSitesComponent } from './user-associate-sites/user-associate-sites.component';
import { UserSecurityComponent } from './user-security/user-security.component';

@NgModule({
	declarations: [
		EditUserComponent
		, RegisterAuthDeviceModalComponent
		, UserChangePasswordModalComponent
		, UserLoginHistoryComponent
		, UserMultiFactorAuthenticationComponent
		, UserMouComponent
		, UserPermissionsModalComponent
		, UserNotificationComponent
        , UserAssociateSitesComponent
        , UserSecurityComponent
	]
    , imports: [ 
		RouterModule
		, CommonModule
		, SharedModule 
	]
    , exports: [ 
		EditUserComponent
		, UserLoginHistoryComponent
		, UserMultiFactorAuthenticationComponent 
	]
})
export class EditUserModule { }
